define(["exports", "@babel/runtime/helpers/esm/extends", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "react", "styled-components", "../../molecules/AccordionProvider"], function (_exports, _extends2, _objectWithoutPropertiesLoose2, _react, _styledComponents, _AccordionProvider) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);
  var _excluded = ["children", "id", "onClick", "onKeyDown"];

  var CollapseButton = _styledComponents.default.button.withConfig({
    displayName: "AccordionHeader__CollapseButton",
    componentId: "sc-1pn9ble-0"
  })(["width:100%;"]);

  var AccordionHeader = function AccordionHeader(_ref) {
    var children = _ref.children,
        id = _ref.id,
        _onClick = _ref.onClick,
        _onKeyDown = _ref.onKeyDown,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);

    var _useAccordionContext = (0, _AccordionProvider.useAccordionContext)(),
        refMap = _useAccordionContext.refMap,
        currentKey = _useAccordionContext.currentKey,
        handleKeyDown = _useAccordionContext.handleKeyDown,
        handleClick = _useAccordionContext.handleClick;

    return /*#__PURE__*/_react.default.createElement(CollapseButton, (0, _extends2.default)({
      ref: function ref(_ref2) {
        return _ref2 ? refMap.set(id, _ref2) : refMap.delete(id);
      },
      tabIndex: currentKey === id ? 0 : -1,
      onKeyDown: function onKeyDown(event) {
        handleKeyDown(event, id);

        _onKeyDown();
      },
      onClick: function onClick() {
        handleClick(id);

        _onClick();
      },
      id: id,
      role: "tab",
      "aria-expanded": currentKey === id,
      "aria-controls": id + "-region",
      type: "button"
    }, rest), children);
  };

  AccordionHeader.defaultProps = {
    onClick: function onClick() {},
    onKeyDown: function onKeyDown() {}
  };
  var _default = AccordionHeader;
  _exports.default = _default;
});